__turbopack_context__.v({
  "activeToggle": "SaftAgreementModal-module__hp9lLq__activeToggle",
  "conversionResult": "SaftAgreementModal-module__hp9lLq__conversionResult",
  "errorMessage": "SaftAgreementModal-module__hp9lLq__errorMessage",
  "formDescription": "SaftAgreementModal-module__hp9lLq__formDescription",
  "formGroup": "SaftAgreementModal-module__hp9lLq__formGroup",
  "inputField": "SaftAgreementModal-module__hp9lLq__inputField",
  "inputToggleContainer": "SaftAgreementModal-module__hp9lLq__inputToggleContainer",
  "okButton": "SaftAgreementModal-module__hp9lLq__okButton",
  "saftForm": "SaftAgreementModal-module__hp9lLq__saftForm",
  "saftModalContainer": "SaftAgreementModal-module__hp9lLq__saftModalContainer",
  "saftModalContent": "SaftAgreementModal-module__hp9lLq__saftModalContent",
  "saftModalInternalContentWrapper": "SaftAgreementModal-module__hp9lLq__saftModalInternalContentWrapper",
  "saftModalOverlay": "SaftAgreementModal-module__hp9lLq__saftModalOverlay",
  "submitButton": "SaftAgreementModal-module__hp9lLq__submitButton",
  "successMessage": "SaftAgreementModal-module__hp9lLq__successMessage",
  "toggleButton": "SaftAgreementModal-module__hp9lLq__toggleButton",
});
